import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const reportApi = {
  create: (body) => imRequest.post(`${IM_API}/reports`, body),
};
